import React from 'react';
import BarButtonFw, {BUTTON_DEFAULT} from '../../../framework/bar-button/BarButtonFw';
import FormFw from '../../../framework/form/FormFw';
import GridFw, { COLUMN_DEFAULT } from '../../../framework/grid/GridFw'
import { BasePage } from "../../../framework/pages/BasePage";  
import { DateUtil } from '../../../util/DateUtil';
import { DATE_FORMAT,MIME_TYPE } from '../../../constants/constants';
import { DocumentPreview } from '../../viewDocument/DocumentPreview';  
import { LoadingUtil } from '../../../util/LoadingUtil';
import { EnvConstants } from '../../../EnvConstants';
import { DonwloadUtil } from '../../../util/DonwloadUtil'; 
import { getGridServerDefaultParams } from '../../shared/util/getGridServerDefaultParams';

import FormGridFw, { FORM_GRID_MODE } from '../../../framework/form-grid/FormGridFw';
import { MessageUtil } from '../../../util/MessageUtil';
import { SELECTION_TYPE } from '../../../framework/grid/GridFw';
import { ReportUtil } from "../../../util/ReportUtil";
import { UserUtil } from '../../../util/UserUtil';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import confirm from 'antd/lib/modal/confirm';
import { LoadUtil } from '../../../framework/util/LoadUtil';
import { ICON } from '../../../constants/iconConstants';

import { DuplicarCotizacionModal } from './modals/DuplicarCotizacionModal';

export class CotizacionesAdminPage extends BasePage {

    createPageProperties = (pageApi) => { 
    return {
        title: 'COTIZACIONES',
         barHeader: {
             fields:[
                 {...BUTTON_DEFAULT.NEW, label:'Nueva Cotizacion', link: '/cotizaciones/cotizaciones/new'}
             ]
         }
        };
    }
          
 
    renderPage(pageApi) {
        const getGrid = () => pageApi.getComponent('grid');
        const getForm = () => pageApi.getComponent('form');

        const DescargarPDFCotizacion = (params, nomArchivo) => {
            const url = EnvConstants.GET_REPORT2_URL() + "CotizacionMa";     
            const archivo = `Cotizacion_${nomArchivo}`;

            LoadingUtil.loadShow();
            ReportUtil.donwloadFromPost(url, params, archivo)
            .then(() => LoadingUtil.loadHide())
            .catch(x => {
                console.error(x)
                LoadingUtil.loadHide();
            });
        }


        const DocumentPreviewModal = (data) => {
            return {
                width: 950,
                maskClosable: true,
                closable: false,
                component: <DocumentPreview name={data} getParentApi={pageApi.getApi} />
            }
        };

         const DuplicarCotizacionModalConfig = (data, grid) => {
             let obj = { data, grid}
             return {
                 width: 950,
                 maskClosable: false,
                 component: <DuplicarCotizacionModal name={obj} getParentApi={pageApi.getApi} />
             }
         };

         const RetornaVisulizacionBoton = (estado, opcion) => {
            let opciones = {
                pendiente: ['crear_version', 'clonar_version', 'editar', 'anular', 'descargar_excel_generada', 'descargar_cotizacion_generada', 'visualizar_cotizacion_generada'],
                en_revision: ['crear_version', 'clonar_version'],
                revisado: ['crear_version', 'clonar_version', 'descargar_excel_generada', 'descargar_cotizacion_generada', 'visualizar_cotizacion_generada'],
                aprobado: ['crear_version', 'clonar_version', 'anular', 'descargar_excel_aprobada', 'descargar_cotizacion_aprobada', 'visualizar_cotizacion_aprobada', 'descargar_excel_ejecutada',],
                anulado: ['clonar_version', 'descargar_excel_generada', 'descargar_cotizacion_generada', 'visualizar_cotizacion_generada']
            }
            
            let arrValidacion = [
                {
                    estado: 'Pendiente',
                    opciones: opciones.pendiente
                },
                {
                    estado: 'En Revisión',
                    opciones: opciones.en_revision
                },
                {
                    estado: 'Revisado',
                    opciones: opciones.revisado
                },
                {
                    estado: 'Aprobado',
                    opciones: opciones.aprobado
                },
                {
                    estado: 'Anulado',
                    opciones: opciones.anulado
                },
            ]

            const objCoti = arrValidacion.find(el => el.estado === estado) || {};
            let viewBoton = objCoti?.opciones?.includes(opcion);
            return viewBoton || false;
        }

        const formConfig = {
            layout: 'vertical',
            values: {
                estado: 4,
                fecha_desde: DateUtil.getDate2(15),
                fecha_hasta: DateUtil.getDate
            },
            fields:[               
                {name: 'doc_nro', label:'Nro. Cotización :', column: 3}, 
                {type: 'select', name:'estado', label:'Estado', column: 4,  
                    load: {
                        dataList: [
                            {label: 'Todos', value: 4},
                            {label: 'Pendiente', value: 1},
                            {label: 'Aprobado', value: 2}, 
                            {label: 'Anulado', value: 3}, 
                        ]
                    }
                },  
                {type: 'date', name:'fecha_desde', label:'Desde', column: 2, format: DATE_FORMAT.DDMMYYYY, inputFormat: DATE_FORMAT.YYYYMMDD},  
                {type: 'date', name:'fecha_hasta', label:'Hasta', column: 2, format: DATE_FORMAT.DDMMYYYY, inputFormat: DATE_FORMAT.YYYYMMDD},
            ]
        };
 
        const gridConfig = {
            title: '',
            showIndex: true,
            autoLoad: true,
            pagination: {server: true},
            selection: {type: SELECTION_TYPE.MULTIPLE},
            load: { 
                queryId: 813 ,
                params: {
                    id_user: UserUtil.getUserId()
                },
                hideMessage: true,
                hideMessageError: true,
            },
            fields:[  
                {name:'doc_nro', label:'Nro Cotizacion'},
                {name:'doc_nroSS', label:'Nro Solicitud'},
                {name:'raz_soc', label:'Empresa'},
                {name:'SOLICITANTE', label:'Solicitante'},
                {name:'fecha_emision', label:'Fecha Emision'},
                {name:'monto', label:'Monto'},
                {name:'estado', label:'Estado'},
                {...COLUMN_DEFAULT.EDIT, label: 'Opciones', colSpan: 7, title: 'Editar', color: 'blue', 
                    link: (value, row, index) => `/cotizaciones/cotizaciones/${row.estado_tab}/${row.id_doc}`, 
                     fnVisible: (value, row, index) => {
                        return RetornaVisulizacionBoton(row?.estado, 'editar')
                    }, 
                }, 
                {...COLUMN_DEFAULT.COPY, title:'Clonar Versión', color:'orange', colSpan: 0, onClick: (value, row, index)=> 
                    {
                        pageApi.showModal(DuplicarCotizacionModalConfig(row, getGrid()));
                    }
                    // fnVisible: (value, row, index) => {
                    //     return RetornaVisulizacionBoton(row?.estado, 'clonar_version')
                    // } 
                },
                {...COLUMN_DEFAULT.CANCEL, icon: ICON.DELETE, colSpan: 0, title: 'Eliminar', color: 'red',
                    onClick: (value, row) => { 
                        confirm({
                            title: '¿Desea eliminar la Cotización?',
                            icon: <ExclamationCircleOutlined />,
                            content: 'N° de Cotización:  ' + row.doc_nro,
                            onOk() {
                                LoadUtil.loadByQueryId({
                                    url: EnvConstants.GET_FW_FORM_URL_UPDATE_BASE(),
                                    queryId: 252,
                                    reqParams: {
                                        params: {id_doc: row.id_doc, id_user: UserUtil.getUserId()},
                                    },
                                    fnOk: (resp) => {
                                        getGrid().load({params:getForm().getData()});
                                        MessageUtil("success", resp.message, "");
                                    },
                                });
                            }
                        })
                    },
                    fnVisible: (value, row, index) => {
                        return RetornaVisulizacionBoton(row?.estado, 'anular')
                    }, 
                },
                {...COLUMN_DEFAULT.DOWNLOAD, title:'Descargar Cotización Generada', color:'black', colSpan: 0, onClick: (value, row, index)=> 
                        {       
                            const params = { queryId: 858, params: { id_doc: row.id_doc } };
                            const version = `0${row.version}`.slice(-2);
                            const nomArchivo = `Pendiente_${row.doc_nro} ${version}.pdf`;
                            DescargarPDFCotizacion(params, nomArchivo);
                        },
                        fnVisible: (value, row, index) => {
                            return RetornaVisulizacionBoton(row?.estado, 'descargar_cotizacion_generada')
                        }  
                },
                {...COLUMN_DEFAULT.PDF, title:'Visualizar Cotización Generada', color:'rgb(176, 0, 45)', colSpan: 0, onClick: (value, row, index)=> 
                    {
                        LoadingUtil.loadShow();
                        let url = EnvConstants.GET_REPORT2_URL() + 'CotizacionMa';
                        DonwloadUtil.donwloadBlob(url, {queryId: 858, params: {id_doc: row.id_doc}}, "Cotizacion_Pendiente_"+row.doc_nro+".pdf").then(x => {                        
                            var reader = new FileReader();
                            reader.readAsDataURL(x.blob); 
                            reader.onloadend = function() {
                                var base64data = reader.result;    
                                let obj = {
                                    url: base64data,
                                    type_file: MIME_TYPE.pdf
                                }
                                pageApi.showModal(DocumentPreviewModal(obj));
                                LoadingUtil.loadHide();
                            }
                        }).catch(x => {
                            console.error(x)
                            LoadingUtil.loadHide();
                        });
                    },
                    fnVisible: (value, row, index) => {
                        return RetornaVisulizacionBoton(row?.estado, 'visualizar_cotizacion_generada')
                    }                
                },
                {...COLUMN_DEFAULT.DOWNLOAD, title:'Descargar Cotización Aprobada', color:'black', colSpan: 0, onClick: (value, row, index)=> 
                    {       
                        const params = { queryId: 860, params: { id_doc: row.id_doc } };
                        const nomArchivo = `Aprobada_${row.doc_nro.trim()}.pdf`;
                        DescargarPDFCotizacion(params, nomArchivo);
                    },
                    fnVisible: (value, row, index) => {
                        return RetornaVisulizacionBoton(row?.estado, 'descargar_cotizacion_aprobada')
                    }
                },
                {...COLUMN_DEFAULT.PDF, title:'Visualizar Cotización Aprobada', color:'rgb(176, 0, 45)', colSpan: 0, onClick: (value, row, index)=> 
                    {
                        LoadingUtil.loadShow();

                        let url = EnvConstants.GET_REPORT2_URL() + 'CotizacionMa';
                        DonwloadUtil.donwloadBlob(url, {queryId: 860, params: {id_doc: row.id_doc}}, "Cotizacion_Aprobada_"+row.doc_nro+".pdf").then(x => {                            
                            var reader = new FileReader();
                            reader.readAsDataURL(x.blob); 
                            reader.onloadend = function() {
                                var base64data = reader.result;    
                                let obj = {
                                    url: base64data,
                                    type_file: MIME_TYPE.pdf
                                }
                                pageApi.showModal(DocumentPreviewModal(obj));
                                LoadingUtil.loadHide();
                            }
                        }).catch(x => {
                            console.error(x)
                            LoadingUtil.loadHide();
                        });
                    },
                     fnVisible: (value, row, index) => {
                         return RetornaVisulizacionBoton(row?.estado, 'visualizar_cotizacion_aprobada')

                     }
                },
                    
            ]
        };
    
        const barButtonconfig = {
            fields:[
                {...BUTTON_DEFAULT.SEARCH, onClick: () => getGrid().load({params:getForm().getData()})},
                {...BUTTON_DEFAULT.CLEAR1, onClick: () => getForm().setData({
                    doc_nro: '',
                    estado: 4,
                    fecha_desde: DateUtil.getDate2(15),
                    fecha_hasta: DateUtil.getDate
                })},
                {...BUTTON_DEFAULT.NEW, label: 'Ejecutar Servicio', onClick: () => {
                    if (getGrid()?.selectedItem?.length > 1) {
                        MessageUtil(
                            "warning",
                            'Solo puedes escoger una cotización.',
                            ""
                        );
                        return;
                    }

                    if (getGrid()?.selectedItem[0].estado != "Aprobado") {
                        MessageUtil(
                            "warning",
                            'No se puede ejecutar el servicio porque la cotización esta en estado ' + getGrid()?.selectedItem[0].estado,
                            ""
                        );
                        return;
                    }
                    
                    if (getGrid()?.selectedItem[0].id_SS != null) {
                        MessageUtil(
                            "warning",
                            'La cotización ya esta asociada a una Solicitud de Servicio',
                            ""
                        );
                        return;
                    }

                    if (getGrid()?.selectedItem?.length > 0) {
                        const idCoti = getGrid()?.selectedItem[0].id_doc;
                        sessionStorage.setItem("ruta_retorno_ejecutar_servicio", "/cotizaciones/cotizaciones-admin");
                        this.props.history.push(`/servicios-ejecutados/servicios-ejecutados/1/${idCoti}`)
                    }
                }}
            ]
        }
    
        return (
            <>
                <FormFw
                    name="form"
                    getParentApi={pageApi.getApi}
                    config={formConfig}
                />
                <BarButtonFw  
                    name="bar"
                    getParentApi={pageApi.getApi}
                    config={barButtonconfig}
                />
                <GridFw 
                    name="grid"
                    getParentApi={pageApi.getApi}
                    config={gridConfig} 
                />
            </>
        )
    }
}
